// extracted by mini-css-extract-plugin
module.exports = {"loginForm":"login_loginForm__X-YfN"};